// extracted by mini-css-extract-plugin
export var sliderRange = "_li-2";
export var sliderRoot = "_li-0";
export var sliderThumb = "_li-3";
export var sliderTrack = "_li-1";